module.exports = __webpack_public_path__ + "img/wd.d2af82b7.png";